import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { findArray } from "helpers/utils";

const PreviousCompetitor = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let trial = false
    let qual = false
    let round1 = false
    let final = false

    const training = data?.results?.eventUnitCode.includes('TRNO01') || data?.results?.eventUnitCode.includes('TRNO02')  
    || data?.results?.eventUnitCode.includes('TRNO03')

    if (data?.results?.eventUnitCode.includes('FNL-TR') || data?.results?.eventUnitCode.includes('QUALTR') 
    || training){
        trial = true
    } else if (data?.results?.eventUnitCode.includes('QUAL0001')){
        qual = true
    } else if (data?.results?.eventUnitCode.includes('FNL-0001')){
        round1 = true
    } else if (data?.results?.eventUnitCode.includes('FNL-0002')){
        final = true
    }

    let competitorCode = data?.results?.currentExtendedInfos && findArray(data?.results?.currentExtendedInfos, { ei_type: ['DISPLAY'], ei_code: ['PREVIOUS'] })?.ei_value

    let previousCompetitor = data?.results?.items ? data?.results?.items?.find(item => item.participant.code === competitorCode) : ''

    let gate = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'GATE_NUM') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'GATE_NUM')?.er_value : ''

    let gatePoints = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'GATE_NUM') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'GATE_NUM')?.er_value2 : ''

    let speed = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'SPEED') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'SPEED')?.er_value : ''

    let distance = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIST') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIST')?.er_value : ''

    let distancePoints = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIST') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIST')?.er_value2 : ''

    let wind = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'WIND_SPEED') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'WIND_SPEED')?.er_value : ''

    let windPoints = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'WIND_SPEED') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'WIND_SPEED')?.er_value2 : ''

    let judgePoints = ''
    if(!trial){
        judgePoints = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'TOT' && i?.er_type === 'JUDGE') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'TOT')?.er_value : ''
    }

    let finalPoints,totalPoints = ''
    if(final){
        finalPoints = previousCompetitor?.resultData ? previousCompetitor?.resultData : ''
        totalPoints = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'CUMULATIVE') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'CUMULATIVE')?.er_value : ''
    }else{
        totalPoints = previousCompetitor?.resultData ? previousCompetitor?.resultData : ''
    }

    let rank = previousCompetitor?.resultRank ? previousCompetitor?.resultRank : ''

    return (
        <>
            {previousCompetitor && (trial || qual)
                ?
                <>
                    <div className="fw-bold"><Label data={'HeaderPreviousCompetitor'} /></div>
                    <table class="table">
                        <thead>
                            <tr>
                                <th className="text-center w-5" scope="col"><Label data={'HeaderBib'} /></th>
                                <th className="text-start w-40" scope="col"><Label data={'HeaderName'} /></th>
                                <th colSpan="2" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <td className="text-center">{previousCompetitor?.bib}</td>
                            <td className="text-start"><Competitor hidePicture={true} alwaysNoc={true} {...previousCompetitor?.participant} /></td>
                            <td>
                                {trial
                                    ?
                                    <>
                                        <Label data="HeaderGate/GatePoints" sport={mirs_discipline} />:&ensp;{gate} / {gatePoints}<br />
                                        <Label data="HeaderSpeed" sport={mirs_discipline} />:&ensp;{speed}<br />
                                        <Label data="HeaderDistance/DistancePoints" sport={mirs_discipline} />:&ensp;{distance} / {distancePoints}<br />
                                        <Label data="HeaderWind/WindPoints" sport={mirs_discipline} />:&ensp;{wind} / {windPoints}<br />
                                        <l className="fw-bold"><Label data="HeaderTotalPoints" />:&ensp;{totalPoints}</l><br />
                                        <l className="fw-bold"><Label data="HeaderRank" />:&ensp;{rank}</l>
                                    </>
                                    : 
                                    <>
                                        <Label data="HeaderGate/GatePoints" sport={mirs_discipline} />:&ensp;{gate} / {gatePoints}<br />
                                        <Label data="HeaderSpeed" sport={mirs_discipline} />:&ensp;{speed}<br />
                                        <Label data="HeaderDistance/DistancePoints" sport={mirs_discipline} />:&ensp;{distance} / {distancePoints}<br />
                                        <Label data="HeaderWind/WindPoints" sport={mirs_discipline} />:&ensp;{wind} / {windPoints}<br />
                                        <Label data="HeaderJudgesPoints" />:&ensp;{judgePoints}<br />
                                        <l className="fw-bold"><Label data="HeaderTotalPoints" />:&ensp;{totalPoints}</l><br />
                                        <l className="fw-bold"><Label data="HeaderRank" />:&ensp;{rank}</l>
                                    </>
                                }
                            </td>
                        </tbody>
                    </table>
                </>
                : previousCompetitor && (final || round1)
                    ?
                    <>
                        <div className="fw-bold"><Label data={'HeaderPreviousCompetitor'} /></div>
                        <table class="table">
                            <thead>
                                <tr>
                                    {round1
                                        ? <th className="text-center w-5" scope="col"><Label data={'HeaderBib'} /></th>
                                        : <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                    }
                                    <th className="text-start w-40" scope="col"><Label data={'HeaderName'} /></th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <td className="text-center" rowSpan='4'>{previousCompetitor?.bib}</td>
                                <td className="text-start"><Competitor hidePicture={true} alwaysNoc={true} {...previousCompetitor?.participant} /></td>
                                <td>
                                    {round1
                                        ?
                                        <>
                                            <Label data="HeaderGate/GatePoints" sport={mirs_discipline} />
                                            :&ensp;
                                            {gate}
                                            {gatePoints
                                                ? ' / '+gatePoints
                                                : ''
                                            }
                                            <br />
                                            <Label data="HeaderSpeed" sport={mirs_discipline} />:&ensp;{speed}<br />
                                            <Label data="HeaderDistance/DistancePoints" sport={mirs_discipline} />:&ensp;{distance} / {distancePoints}<br />
                                            <Label data="HeaderWind/WindPoints" sport={mirs_discipline} />:&ensp;{wind} / {windPoints}<br />
                                            <Label data="HeaderJudgesPoints" />:&ensp;{judgePoints}<br />
                                            <l className="fw-bold"><Label data="HeaderTotalPoints" />:&ensp;{totalPoints}</l><br />
                                            <l className="fw-bold"><Label data="HeaderRank" />:&ensp;{rank}</l>
                                        </>
                                        :
                                        <>
                                            <Label data="HeaderGate/GatePoints" sport={mirs_discipline} />
                                            :&ensp;
                                            {gate}
                                            {gatePoints
                                                ? ' / '+gatePoints
                                                : ''
                                            }
                                            <br />
                                            <Label data="HeaderSpeed" sport={mirs_discipline} />:&ensp;{speed}<br />
                                            <Label data="HeaderDistance/DistancePoints" sport={mirs_discipline} />:&ensp;{distance} / {distancePoints}<br />
                                            <Label data="HeaderWind/WindPoints" sport={mirs_discipline} />:&ensp;{wind} / {windPoints}<br />
                                            <Label data="HeaderJudgesPoints" />:&ensp;{judgePoints}<br />
                                            <Label data="HeaderFinalPoints" sport={mirs_discipline}/>:&ensp;{finalPoints}<br />
                                            <l className="fw-bold"><Label data="HeaderTotalPoints" />:&ensp;{totalPoints}</l><br />
                                            <l className="fw-bold"><Label data="HeaderRank" />:&ensp;{rank}</l>
                                        </>
                                    }
                                </td>
                            </tbody>
                        </table>
                    </>
                    :
                    <></>
            }
        </>
    )
}

export default PreviousCompetitor;